import React, { useLayoutEffect, useRef } from 'react'
import { gsap } from 'gsap'

const Nophotocouple = ({ details }) => {

   const sectionRef = useRef(null)
  const frameRef = useRef(null)

  const hasGrandParents =
    details?.groomGrandParents || details?.brideGrandParents;


    const renderPersonCard = ({
    fullname,
    parentprefix,
    parentsName,
    grandParentsPrefix,
    grandParentsName,
  }) => {
    return (
      <div className="couple-person" data-aos="fade-up">

        <div className="couple-grandparents">
          {grandParentsName && (
  <p>
    {grandParentsPrefix} {grandParentsName}
  </p>
)}
        </div>

        <h1 className="couple-name">
          {fullname}
        </h1>

        <div className="couple-parents">
        {parentsName && (
  <p>
    {parentprefix} {parentsName}
  </p>
)}
        </div>

      </div>
    );
  };

    const groomCard = () =>
    renderPersonCard({
      fullname: details?.groomFullName || "Groom Full Name",
      parentprefix: details?.groomParentsPrefix,
      parentsName: details?.groomParents,
      grandParentsPrefix: details?.groomGrandParentsPrefix,
      grandParentsName: details?.groomGrandParents,
    });

  const brideCard = () =>
    renderPersonCard({
      fullname: details?.brideFullName || "Bride Full Name",
      parentprefix: details?.brideParentsPrefix,
      parentsName: details?.brideParents,
      grandParentsPrefix: details?.brideGrandParentsPrefix,
      grandParentsName: details?.brideGrandParents,
    });

     useLayoutEffect(() => {

    const ctx = gsap.context(() => {

      gsap.fromTo(
        frameRef.current,
        {
          autoAlpha: 0,
          scale: 0.985,
        },
        {
          autoAlpha: 1,
          scale: 1,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 55%",
            once: true,
          },
        }
      )

    }, sectionRef)

    return () => ctx.revert()

  }, [])

  const desktopFrameBaseUrl = "https://res.cloudinary.com/depixc8dq/image/upload/v1792631861/aamantran%20assets/theme1-couple-frame-desktop_d08hwl.png";
const mobileFrameBaseUrl = "https://res.cloudinary.com/depixc8dq/image/upload/v1792631860/aamantran%20assets/floral1-mobile-frame_wtrtcw.png";
const extendedFrameBaseUrl = "https://res.cloudinary.com/depixc8dq/image/upload/v1792631861/aamantran%20assets/floral1-mobile-frame-extended_sxehvw.png";

const getOptimizedFrameUrl = (url, width) =>
  url.replace("/upload/", `/upload/f_auto,q_auto,w_${width}/`);

const desktopFrameSrc = getOptimizedFrameUrl(desktopFrameBaseUrl, 1080);

const mobileFrameBaseUrlToUse = hasGrandParents
  ? extendedFrameBaseUrl
  : mobileFrameBaseUrl;

const mobileFrameSrc = getOptimizedFrameUrl(
  mobileFrameBaseUrlToUse,
  640
);

const mobileFrameSrcSet = [320, 640, 1080]
  .map(
    (width) =>
      `${getOptimizedFrameUrl(mobileFrameBaseUrlToUse, width)} ${width}w`
  )
  .join(", ");


  return (
    <section className="couple-section no-photo-couple"  ref={sectionRef}>

      {/* <picture>
        <source
          media="(min-width:768px)"
          srcSet="/theme1-couple-frame-desktop.png"
        />

        <img
          ref={frameRef}
          src={
            hasGrandParents
              ? "/floral1-mobile-frame-extended.png"
              : "/floral1-mobile-frame.png"
          }
          alt="Couple Frame"
          className={`couple-frame ${
            hasGrandParents ? "extended-couple-frame" : ""
          }`}
        />
      </picture> */}


        <picture>
  <source
    media="(min-width: 768px)"
    srcSet={desktopFrameSrc}
  />

  <img
    ref={frameRef}
    src={mobileFrameSrc}
    srcSet={mobileFrameSrcSet}
    sizes="(max-width: 480px) 320px, (max-width: 767px) 640px"
    alt="Couple Frame"
    className={`couple-frame ${
      hasGrandParents ? "extended-couple-frame" : ""
    }`}
  />
</picture>

      <div className="couple-inner">

        <h2 className="couple-heading" data-aos="fade-up">
          {details?.sectionHeading}
        </h2>

        <div className="couple-content">

          {details?.displayOrder === "groomFirst" ? (
            <>
              {groomCard()}

              <div  className={`couple-divider ${hasGrandParents ? "extended-space" : "" }`} data-aos="fade-up">
                &
              </div>

              {brideCard()}
            </>
          ) : (
            <>
              {brideCard()}

              <div  className={`couple-divider ${hasGrandParents ? "extended-space" : "" }`} data-aos="fade-up">
                &
              </div>

              {groomCard()}
            </>
          )}

        </div>

      </div>
    </section>
  )
}

export default Nophotocouple